"use strict";

exports.__esModule = true;
exports.defaultMaskChar = exports.defaultCharsRules = void 0;
var defaultCharsRules = {
  '9': '[0-9]',
  'a': '[A-Za-z]',
  '*': '[A-Za-z0-9]'
};
exports.defaultCharsRules = defaultCharsRules;
var defaultMaskChar = '_';
exports.defaultMaskChar = defaultMaskChar;


//////////////////
// WEBPACK FOOTER
// ./~/react-input-mask/lib/constants/index.js
// module id = 134
// module chunks = 0